/**
 * Detect iOS >= 18 and hide blur effects
 */
(function() {
  // Detect iOS version
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  if (!isIOS) {
    return; // Not iOS, exit early
  }

  // Extract iOS version from user agent
  // iOS user agent format: "OS 16_0" or "OS 16_1" etc.
  const match = navigator.userAgent.match(/OS (\d+)[_\d]*/);
  
  if (!match) {
    return; // Couldn't detect version
  }

  const iosVersion = parseInt(match[1], 10);
  
  // Check if iOS version is >= 18
  if (iosVersion >= 18) {
    // Create a style element to inject CSS
    const style = document.createElement('style');
    style.textContent = '[class*="blur-"],\n[class*="blur-["] {\n  display: none !important;\n}';
    
    // Insert the style into the document head
    document.head.appendChild(style);
  }
})();

